import React from 'react';

import { type RouteComponentProps, Route, Switch } from 'react-router';

import LazyComponent from '@fd/ui/LazyComponent';

import { lazyWithRetry } from '../../helpers/utilities';
import ErrorBoundary from '../../layouts/Portal/ErrorBoundary';

const Onboarding = lazyWithRetry(() => import('./Onboarding'));
type Props = RouteComponentProps;

const OnboardingRoutes: React.FC<Props> = (props: Props) => {
  const {
    match: { path },
  } = props;

  return (
    <ErrorBoundary identifier="onboarding-v2">
      <Switch>
        <Route
          path={`${path}`}
          render={() => (
            <LazyComponent>
              <Onboarding />
            </LazyComponent>
          )}
        />
      </Switch>
    </ErrorBoundary>
  );
};

export default OnboardingRoutes;
